module.exports = __webpack_public_path__ + "static/media/sidebarbg.f432cf7d.png";